export default {
  Support: {
    Use: 'Người cần hỗ trợ',
    Phone: 'Số điện thoại liên hệ',
    ErrorTime: 'Thời gian lỗi trên bài giảng',
    Content: 'Nội dung cần hỗ trợ',
    TextConetent: 'Nhập nội dung cần hỗ trợ',
    TextUser: 'Nhập tên người hỗ trợ',
    TextPhone: 'Nhập số điện thoại',
    TextErrorTime: 'Nhập thời gian lỗi',
    TheAnswerWrong: 'Nội dung lỗi',
    TypeError: 'Loại lỗi'
  }
}
